import { useState } from "react";
import { Autocomplete, MenuItem, Stack } from "@mui/material";

import TextField from "./text-field";
import { MenuItemProps, MenuPaperProps } from "../../Components/Form Fields/select-field";

import useDebounce from "../../CustomHooks/useDebounce";
import useAddressAutocomplete from "../../CustomHooks/useAddressAutocomplete";

import { Pin } from "../../Assets/Icons";

export default function AddressAutoCompleteField({ fieldProps = {}, onAddressSelect }) {
  const [openSuggestionMenu, setOpenSuggestionMenu] = useState(false);

  const { value } = fieldProps;

  const debouncedAddress = useDebounce(value, 300);

  const { suggestions, selectPlace } = useAddressAutocomplete(debouncedAddress, onAddressSelect);

  return (
    <Autocomplete
      open={openSuggestionMenu && suggestions?.length > 0}
      onOpen={() => setOpenSuggestionMenu(true)}
      onClose={() => setOpenSuggestionMenu(false)}
      inputValue={value}
      onInputChange={(_, newInputValue) => {
        if (typeof fieldProps.onChange === "function") {
          fieldProps.onChange({ target: { value: newInputValue } });
        }
      }}
      renderInput={(params) => (
        <>
          <input name="address" autoComplete="address" className="d-none" />
          <TextField {...params} autoComplete="none" {...fieldProps} />
        </>
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem
          {...props}
          key={option.place_id}
          selected={selected}
          sx={{ ...MenuItemProps.sx, "&.MuiAutocomplete-option": { padding: "16px 12px" } }}
        >
          <Stack display="flex" flexDirection="row" alignItems="flex-start" gap="10px">
            <Pin />
            <Stack className="text-sm-medium" display="flex" gap="4px">
              <div>{option.structured_formatting.main_text}</div>
              <div>{option.structured_formatting.secondary_text}</div>
            </Stack>
          </Stack>
        </MenuItem>
      )}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.structured_formatting?.main_text || option.description || ""
      }
      isOptionEqualToValue={(option, value) => option.description === value.description}
      options={suggestions}
      onChange={(_, suggestion) => selectPlace(suggestion.place_id)}
      slotProps={{ paper: MenuPaperProps }}
      freeSolo
      forcePopupIcon={false}
      disableClearable
    />
  );
}
